import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './StoreGuide.css';

// public/images/guide/ 폴더에 파일명 맞춰 이미지 넣으면 자동 표시
const GUIDE_STEPS = [
  {
    id: 'signup-intro',
    title: '회원가입',
    icon: '📱',
    image: '/images/guide/signup-intro.png',
    subtitle: '1단계: 회원가입 소개',
    content: `
      <p>내기프트에 접속하여 우측 상단의 <strong>"회원가입"</strong> 버튼을 클릭하세요.</p>
      <p>그 동안 스타벅스 기프트를 보면서 부러워만 하셨죠?<br/>이젠 우리 상점만의 기프트를 만들어 보세요!</p>
      <ul>
        <li>✓ 선물하기 QR코드 제공</li>
        <li>✓ 모바일 페이지 자동 생성</li>
        <li>✓ 어디든 홍보 가능</li>
      </ul>
    `,
  },
  {
    id: 'signup-terms',
    title: '회원가입',
    icon: '📋',
    image: '/images/guide/signup-terms.png',
    subtitle: '2단계: 약관 동의',
    content: `
      <p><strong>약관을 읽으신 후 동의해주세요.</strong></p>
      <ul>
        <li>서비스 이용약관 동의</li>
        <li>개인정보 수집 및 이용동의</li>
        <li>마케팅 정보 수신 동의 (선택)</li>
      </ul>
      <p>모두 동의하신 후 다음 단계로 진행하세요.</p>
    `,
  },
  {
    id: 'signup-store-info',
    title: '회원가입',
    icon: '🏪',
    image: '/images/guide/signup-store-info.png',
    subtitle: '3단계: 상점 정보 입력',
    content: `
      <h4>상점 기본 정보를 입력합니다.</h4>
      <div class="form-section"><h5>📸 상점 로고</h5><p>사장님 가게 간판이나 가게 내부 사진을 이용하셔도 됩니다.</p></div>
      <div class="form-section"><h5>📞 연락처</h5><p>가게 전화번호나 사장님 번호를 넣어주세요.</p></div>
      <div class="form-section"><h5>💳 정산 계좌</h5><p>기프트 판매금액이 입금될 계좌를 적어주세요.</p></div>
      <div class="form-section"><h5>🔗 소셜 링크</h5><p>네이버지도, 카카오맵, 인스타가 있는 경우에 링크를 넣어주세요.</p></div>
    `,
  },
  {
    id: 'signup-account',
    title: '회원가입',
    icon: '🔐',
    image: '/images/guide/signup-account.png',
    subtitle: '4단계: 관리자 계정 설정',
    content: `
      <h4>관리자 계정으로 사용할 정보를 설정합니다.</h4>
      <div class="form-section"><h5>👤 아이디</h5><p>로그인할 때 사용할 아이디를 정해주세요.</p></div>
      <div class="form-section"><h5>🔑 비밀번호</h5><p>안전한 비밀번호를 설정해주세요.</p></div>
      <div class="form-section"><h5>👨‍💼 담당자 정보</h5><p>담당자 이름, 이메일, 전화번호를 입력해주세요.</p></div>
      <p style="margin-top:16px;font-weight:600;">모든 정보 입력을 완료했다면 <strong>"회원가입"</strong> 버튼을 클릭하세요!</p>
    `,
  },
  {
    id: 'signup-complete',
    title: '회원가입',
    icon: '🎉',
    image: '/images/guide/signup-complete.png',
    subtitle: '5단계: 회원가입 완료',
    content: `
      <h3>축하합니다! 회원가입이 완료되었습니다.</h3>
      <p>이제 기프트를 등록할 준비가 되었습니다.</p>
      <div class="success-box">
        <h4>다음 단계</h4>
        <p><strong>"상점관리자"</strong> 버튼을 클릭하면 기프트를 등록할 수 있습니다.</p>
      </div>
    `,
  },
  {
    id: 'gift-register-intro',
    title: '기프트 등록',
    icon: '🎁',
    image: '/images/guide/gift-register-intro.png',
    subtitle: '1단계: 기프트 등록 시작',
    content: `
      <h4>이제 기프트를 등록해봅시다!</h4>
      <div class="instruction-box">
        <p>1. 우측 상단의 <strong>"상점관리자"</strong>를 클릭해주세요.</p>
        <p>2. 좌측 메뉴에서 <strong>"기프트 관리"</strong>를 선택합니다.</p>
        <p>3. 화면 상단의 <strong>"기프트 등록"</strong> 버튼을 눌러주세요.</p>
      </div>
    `,
  },
  {
    id: 'gift-register-form',
    title: '기프트 등록',
    icon: '📝',
    image: '/images/guide/gift-register-form.png',
    subtitle: '2단계: 기프트 정보 입력',
    content: `
      <h4>아래 항목들을 모두 기입해주세요.</h4>
      <div class="form-section"><h5>🎁 기프트명</h5><p>예) "5천원 커피쿠폰", "1만원 세트메뉴"</p></div>
      <div class="form-section"><h5>📸 이미지</h5><p>기프트의 대표 이미지를 업로드하세요.</p></div>
      <div class="form-section"><h5>💬 설명</h5><p>기프트에 대한 간단한 설명을 작성하세요.</p></div>
      <div class="form-section"><h5>💰 판매 가격</h5><p>기프트 가격을 입력하세요. (예: 5000원)</p></div>
      <div class="form-section"><h5>📊 총 발행 수량</h5><p>최대 몇 개까지 판매할지 정해주세요.</p></div>
      <div class="form-section"><h5>📅 판매 기간</h5><p>기프트 판매 시작일과 종료일을 정해주세요.</p></div>
    `,
  },
  {
    id: 'gift-register-complete',
    title: '기프트 등록',
    icon: '✅',
    image: '/images/guide/gift-register-complete.png',
    subtitle: '3단계: 기프트 등록 완료',
    content: `
      <h4>모든 정보를 입력했다면 <strong>"등록"</strong> 버튼을 눌러주세요!</h4>
      <p style="margin-top:16px;">정상적으로 마쳤다면 기프트 정보가 목록에 표시됩니다.</p>
      <div class="info-box">
        <h4>🎯 다음 단계</h4>
        <p>좌측의 <strong>"상점 정보 관리"</strong> 화면을 눌러 QR코드를 확인하고, 가게 테이블이나 카운터에 배치하세요!</p>
      </div>
    `,
  },
  {
    id: 'gift-edit-intro',
    title: '기프트 수정',
    icon: '✏️',
    image: '/images/guide/gift-edit-intro.png',
    subtitle: '1단계: 기프트 수정 소개',
    content: `
      <h3>1분 만에 따라하는 기프트 정보 수정</h3>
      <p>매장을 운영하다 보면 예상치 못한 변수들이 생기기 마련입니다.<br/>그럴 땐 당황하지 마시고 기프트를 수정하면 됩니다!</p>
      <div class="tips-box">
        <h4>수정 가능한 항목</h4>
        <ul>
          <li>💰 <strong>가격 조정</strong> — 원자재 가격이나 물가 변동이 있을 때</li>
          <li>📊 <strong>총 발행 수량</strong> — 매장의 재고 상황에 맞춰 변경</li>
          <li>⏸️ <strong>판매 일시중지</strong> — 매장 사정으로 잠시 판매를 쉴 때</li>
        </ul>
      </div>
    `,
  },
  {
    id: 'gift-edit-steps',
    title: '기프트 수정',
    icon: '🔧',
    image: '/images/guide/gift-edit-steps.png',
    subtitle: '2단계: 수정 방법 & 예시',
    content: `
      <h4>기프트를 수정하는 방법</h4>
      <div class="step-box"><h5>Step 1️⃣</h5><p>관리자로 로그인 후 <strong>"기프트 관리"</strong> 화면에 들어갑니다.</p></div>
      <div class="step-box"><h5>Step 2️⃣</h5><p>수정할 기프트의 <strong>"수정"</strong> 버튼을 눌러주세요.</p></div>
      <div class="step-box">
        <h5>Step 3️⃣</h5>
        <p>기본 정보와 판매 설정이 나타납니다:</p>
        <ul>
          <li><strong>📝 기본 정보</strong> — 기프트 이름, 사진, 홍보문구</li>
          <li><strong>⚙️ 판매 설정</strong> — 가격, 총 발행수량, 판매기간</li>
        </ul>
      </div>
      <div class="step-box"><h5>Step 4️⃣</h5><p>원하는 항목을 수정한 후 <strong>"저장"</strong> 버튼을 클릭합니다.</p></div>
      <h4 style="margin-top:24px;">실제 수정 예시</h4>
      <div class="example-row">
        <div class="example-box">
          <h5>변경 전</h5>
          <ul>
            <li>💰 가격: 4,500원</li>
            <li>📅 판매종료기한: 26년 8월 27일</li>
            <li>📊 총발행수량: 50건</li>
          </ul>
        </div>
        <div class="example-arrow">→</div>
        <div class="example-box example-box-after">
          <h5>변경 후</h5>
          <ul>
            <li>💰 가격: 5,500원</li>
            <li>📅 판매종료기한: 26년 6월 4일</li>
            <li>📊 총발행수량: 30건</li>
          </ul>
        </div>
      </div>
    `,
  },
  {
    id: 'gift-edit-done',
    title: '기프트 수정',
    icon: '🎊',
    image: '/images/guide/gift-edit-done.png',
    subtitle: '3단계: 수정 완료',
    content: `
      <h3>수정이 완료되었습니다!</h3>
      <p>변경된 기프트 정보가 즉시 반영되어 손님들에게 보여집니다.</p>
      <div class="success-box">
        <h4>✅ 수정 완료 체크리스트</h4>
        <ul>
          <li>기프트 목록에서 변경된 정보 확인</li>
          <li>모바일 페이지에서 정상 노출 확인</li>
          <li>판매 상태가 올바르게 설정되었는지 확인</li>
        </ul>
      </div>
      <div class="info-box">
        <h4>📞 도움이 필요하신가요?</h4>
        <p>운영 중 문의사항이 있으시면 내기프트 고객센터로 연락해 주세요.</p>
      </div>
    `,
  },
  {
    id: 'gift-edit-warning',
    title: '기프트 수정',
    icon: '🚨',
    image: '/images/guide/gift-edit-warning.png',
    subtitle: '4단계: 중요한 주의사항',
    content: `
      <h3>⚠️ 가장 중요한 주의사항!</h3>
      <div class="warning-box">
        <h4>판매취소 vs 판매일시중지</h4>
        <p><strong>더 이상 기프트 판매가 불가능하다면</strong> 화면 맨 아래의 <strong>"판매취소"</strong>를 누르면 됩니다.</p>
        <p class="warning-text">⚠️ 하지만 판매취소를 누르면 해당 기프트는 영구적으로 사용이 불가해지며, 기프트 목록에서도 완전히 삭제됩니다!</p>
      </div>
      <div class="tips-box">
        <h4>💡 추천 팁</h4>
        <p>추후에 똑같은 기프트를 다시 판매할 가능성이 조금이라도 남아있다면,<br/><strong>"판매취소"</strong> 대신 <strong>"판매일시중지"</strong>로 전환해 두는 것을 강력히 추천합니다!</p>
      </div>
    `,
  },
  {
    id: 'qr-download',
    title: 'QR 배치',
    icon: '🖨️',
    image: '/images/guide/qr-download.png',
    subtitle: '1단계: QR 코드 출력하기',
    content: `
      <h4>QR 코드를 찾아 출력해 보세요!</h4>
      <div class="step-box"><h5>Step 1️⃣</h5><p>좌측 메뉴에서 <strong>"상점정보관리"</strong> 화면을 눌러주세요.</p></div>
      <div class="step-box"><h5>Step 2️⃣</h5><p>화면 내에서 <strong>QR 코드 이미지</strong>를 확인합니다.</p></div>
      <div class="step-box"><h5>Step 3️⃣</h5><p><strong>"QR 출력"</strong> 버튼을 눌러 인쇄하거나, 이미지를 저장해 두세요.</p></div>
      <div class="tips-box">
        <h4>💡 출력 팁</h4>
        <p>A4 용지 또는 스티커 용지에 출력하면 테이블·카운터에 부착하기 좋습니다.<br/>코팅을 하면 더 오래 사용할 수 있습니다.</p>
      </div>
    `,
  },
  {
    id: 'qr-place',
    title: 'QR 배치',
    icon: '📍',
    image: '/images/guide/qr-place.png',
    subtitle: '2단계: QR 코드 배치하기',
    content: `
      <h4>출력한 QR 코드를 손님 눈에 잘 띄는 곳에 배치하세요!</h4>
      <div class="instruction-box">
        <p>✅ <strong>테이블 위</strong> — 식사 중 자연스럽게 발견할 수 있어요.</p>
        <p>✅ <strong>계산대·카운터</strong> — 결제 시 안내하기 좋아요.</p>
        <p>✅ <strong>입구·메뉴판 옆</strong> — 방문 직후 눈에 들어와요.</p>
      </div>
      <div class="success-box">
        <h4>✅ 배치 완료!</h4>
        <p>손님이 QR을 스캔하면 사장님의 기프트샵으로 바로 연결되어,<br/>원하는 기프트를 골라 지인에게 <strong>선물하기</strong>를 할 수 있습니다.</p>
      </div>
    `,
  },
  {
    id: 'qr-giftpage',
    title: 'QR 배치',
    icon: '🛍️',
    image: '/images/guide/qr-giftpage.png',
    subtitle: '3단계: 손님이 기프트 페이지 방문',
    content: `
      <h3>손님이 QR을 스캔하면 이렇게 됩니다!</h3>
      <div class="step-box"><h5>Step 1️⃣</h5><p>손님이 스마트폰 카메라로 <strong>QR 코드를 스캔</strong>합니다.</p></div>
      <div class="step-box"><h5>Step 2️⃣</h5><p>사장님만의 <strong>기프트샵 페이지</strong>로 바로 이동합니다.<br/>별도 앱 설치 없이 모바일 브라우저에서 바로 열립니다.</p></div>
      <div class="step-box"><h5>Step 3️⃣</h5><p>등록된 기프트 목록 중 원하는 기프트를 골라 <strong>지인에게 선물</strong>할 수 있습니다.</p></div>
      <div class="step-box"><h5>Step 4️⃣</h5><p>선물받은 분은 카카오톡·문자 등으로 기프트를 받아 <strong>매장 방문 시 QR로 사용</strong>합니다.</p></div>
      <div class="success-box">
        <h4>🎉 이제 준비 완료!</h4>
        <p>QR 배치부터 기프트 사용까지 모든 흐름이 연결되었습니다.<br/>손님들이 언제 어디서나 사장님의 기프트를 선물할 수 있습니다.</p>
      </div>
    `,
  },
];

const SECTION_COLORS = {
  '회원가입':   '#667eea',
  '기프트 등록': '#38a169',
  '기프트 수정': '#e67e22',
  'QR 배치':    '#3182ce',
};

const groupedSteps = GUIDE_STEPS.reduce((acc, step, idx) => {
  if (!acc[step.title]) acc[step.title] = [];
  acc[step.title].push({ ...step, globalIdx: idx });
  return acc;
}, {});

export default function StoreGuide() {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const [isPrinting, setIsPrinting] = useState(false);
  const [imgError, setImgError] = useState({});

  const step = GUIDE_STEPS[currentStep];
  const accentColor = SECTION_COLORS[step.title] || '#667eea';
  const progress = ((currentStep + 1) / GUIDE_STEPS.length) * 100;
  const hasImage = step.image && !imgError[step.id];

  const goTo = (idx) => {
    setCurrentStep(idx);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handlePrint = () => {
    setIsPrinting(true);
    setTimeout(() => { window.print(); setIsPrinting(false); }, 500);
  };

  return (
    <div className="sg-wrap">
      {/* 상단 헤더 */}
      <header className="sg-header">
        <div className="sg-header-left">
          <h1 className="sg-title">📚 상점 운영 가이드</h1>
          <p className="sg-subtitle">회원가입부터 기프트 수정까지 쉽게 따라하세요</p>
        </div>
        <div className="sg-header-actions">
          <button className="sg-print-btn" onClick={handlePrint} disabled={isPrinting}>
            🖨️ {isPrinting ? '준비중...' : '인쇄'}
          </button>
          <button className="sg-close-btn-top" onClick={() => navigate('/')}>✕ 닫기</button>
        </div>
      </header>

      <div className="sg-body">
        {/* 사이드바 */}
        <aside className="sg-sidebar">
          {Object.entries(groupedSteps).map(([sectionTitle, steps]) => {
            const color = SECTION_COLORS[sectionTitle] || '#667eea';
            return (
              <div key={sectionTitle} className="sg-section">
                <div className="sg-section-title" style={{ color }}>{sectionTitle}</div>
                <ul className="sg-step-list">
                  {steps.map(s => {
                    const isDone = s.globalIdx < currentStep;
                    const isCurrent = s.globalIdx === currentStep;
                    return (
                      <li
                        key={s.id}
                        className={`sg-step-item ${isCurrent ? 'sg-step-current' : ''} ${isDone ? 'sg-step-done' : ''}`}
                        onClick={() => goTo(s.globalIdx)}
                        style={isCurrent ? { borderLeftColor: color, color } : {}}
                      >
                        <span className="sg-step-dot" style={
                          isCurrent ? { background: color, color: '#fff' }
                          : isDone   ? { background: '#a0aec0', color: '#fff' }
                          : {}
                        }>
                          {isDone ? '✓' : s.globalIdx + 1}
                        </span>
                        <span className="sg-step-label">{s.subtitle}</span>
                      </li>
                    );
                  })}
                </ul>
              </div>
            );
          })}
        </aside>

        {/* 메인 콘텐츠 */}
        <main className="sg-main">
          {/* 진행 바 */}
          <div className="sg-progress-wrap">
            <div className="sg-progress-bar">
              <div className="sg-progress-fill" style={{ width: `${progress}%`, background: accentColor }} />
            </div>
          </div>

          {/* 슬라이드 카드 */}
          <article className="sg-article" key={currentStep}>
            {/* 이미지 존 */}
            <div className={`sg-img-zone ${hasImage ? 'sg-img-zone-filled' : ''}`}>
              {hasImage ? (
                <img
                  src={step.image}
                  alt={step.subtitle}
                  className="sg-img-preview"
                  onError={() => setImgError(prev => ({ ...prev, [step.id]: true }))}
                />
              ) : (
                <div className="sg-img-placeholder">
                  <span className="sg-img-placeholder-icon">🖼️</span>
                  <span className="sg-img-placeholder-text">이미지 준비 중</span>
                  <span className="sg-img-placeholder-sub">{step.image}</span>
                </div>
              )}
            </div>

            {/* 아티클 헤더 */}
            <div className="sg-article-header" style={{ borderLeftColor: accentColor }}>
              <span className="sg-article-icon">{step.icon}</span>
              <div>
                <div className="sg-article-section" style={{ color: accentColor }}>{step.title}</div>
                <h2 className="sg-article-h2">{step.subtitle}</h2>
              </div>
            </div>

            {/* 본문 */}
            <div className="sg-article-content" dangerouslySetInnerHTML={{ __html: step.content }} />
          </article>
        </main>
      </div>

      {/* 하단 고정 네비게이션 */}
      <footer className="sg-footer-nav">
        <div className="sg-footer-inner">
          <button
            className="sg-nav-btn sg-nav-prev"
            onClick={() => goTo(currentStep - 1)}
            disabled={currentStep === 0}
          >
            ← 이전
          </button>

          <div className="sg-footer-dots">
            {GUIDE_STEPS.map((_, i) => (
              <button
                key={i}
                className={`sg-dot ${i === currentStep ? 'sg-dot-active' : ''} ${i < currentStep ? 'sg-dot-done' : ''}`}
                onClick={() => goTo(i)}
                style={i === currentStep ? { background: accentColor } : {}}
              />
            ))}
          </div>

          <button
            className="sg-nav-btn sg-nav-next"
            onClick={() => goTo(currentStep + 1)}
            disabled={currentStep === GUIDE_STEPS.length - 1}
            style={{ background: accentColor }}
          >
            다음 →
          </button>
        </div>
      </footer>
    </div>
  );
}
